import { ReactElement } from "react";

import RollbarProvider from "providers/RollbarProvider";
import ReactQueryClientProvider from "providers/ReactQueryClientProvider";
import PageAlertProvider from "providers/PageAlertProvider";
import OktaSecurityProvider from "providers/OktaSecurityProvider";
import AnalyticsProvider from "providers/AnalyticsProvider";

// Order of providers is from outermost parent to innermost child
const providers = [
  RollbarProvider,
  ReactQueryClientProvider,
  PageAlertProvider,
  OktaSecurityProvider,
  AnalyticsProvider,
];

const CommonRootProviders = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  return providers.reduceRight(
    (acc, Provider) => {
      return <Provider>{acc}</Provider>;
    },
    <>{children}</>,
  );
};

export default CommonRootProviders;
